'use client'
import React from "react";
import cl from 'clsx'
import 'keen-slider/keen-slider.min.css'
import { useKeenSlider } from 'keen-slider/react'
import Title from '@/ui/title';
import Button from '@/ui/button';
import Image from 'next/image';
import { ScrollPanel } from "primereact/scrollpanel";
import styles from './styles.module.css'
import './styles.css'

export default function Looks({dict}) {
    const {
        title,
        title_sm,
        description_1,
        description_2,
        description_3,
        description_4
    } = dict.looks;
    const [sliderRef, instanceRef] = useKeenSlider(
    {
        slidesPerView: 1,
        mode: 'snap',
        loop: true,
    })

    const prevSlide = () => {
        if (instanceRef) instanceRef.current?.prev();
    };

    const nextSlide = () => {
        if (instanceRef) instanceRef.current?.next();
    };

    return (
        <section className={styles.looks} data-name="looks-section">
            <div className={cl(styles.looks__wrapper, "container")}>
                <div className={styles.looks__content}>
                    <Title
                        titleSm={title_sm}
                        title={title}
                    />
                    <ScrollPanel style={{width: '100%', height: '400px'}} className="custombar2">
                        <div className={styles.looks__text_block}>
                            <p className={styles.looks__description}>{description_1}</p>
                            <p className={styles.looks__description}>{description_2}</p>
                            <p className={styles.looks__description}>{description_3}</p>
                            <p className={styles.looks__description}>{description_4}</p>
                        </div>
                    </ScrollPanel>
                    <div className={styles.looks__button_wrapper}>
                        <Button onClick={prevSlide} type='round-left-grey'/>
                        <Button onClick={nextSlide} type='round-right-grey'/>
                    </div>
                </div>
                <div ref={sliderRef} className={cl(styles.looks__image_wrapper, 'keen-slider')}>
                    <Image className='keen-slider__slide' src="/images/look-1.png" width={765} height={570} alt='image'/>
                    <Image className='keen-slider__slide' src="/images/look-2.png" width={765} height={570} alt='image'/>
                    <Image className='keen-slider__slide' src="/images/look-3.png" width={765} height={570} alt='image' />
                </div>
                <div className={styles.looks__image_buttons}>
                    <Button onClick={prevSlide} type='round-left-grey' />
                    <Button onClick={nextSlide} type='round-right-grey' />
                </div>
            </div>
        </section>
    );
}
